// Importing directly from the module rather than the folder
// to optimize bundling and reduce processing times
import MuiAccordion, {
  // eslint-disable-next-line import/named
  AccordionProps as MuiAccordionProps,
} from "@mui/material/Accordion";

export interface AccordionProps extends MuiAccordionProps {
  componentName: string;
}

export const Accordion = ({ componentName, ...props }: AccordionProps) => {
  return (
    <MuiAccordion
      {...props}
      data-testid={`${componentName}-accordion`}
      sx={{
        display: "flex",
        flexDirection: "column",
        border: "1px solid",
        borderColor: "primary.main",
        borderRadius: "2px",
        p: 1,
        ...props.sx,
      }}
    ></MuiAccordion>
  );
};
